export const MAIN_LOADER_LOADING = 'MAIN_LOADER_LOADING';
export const MAIN_LOADER_ERROR = 'MAIN_LOADER_ERROR';
export const MAIN_LOADER_COMPLETE = 'MAIN_LOADER_COMPLETE';
